var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.394142 16.0708C-0.131381 15.5745 -0.131381 14.7757 0.394142 14.2794C0.656903 14.0312 0.997672 13.9071 1.34255 13.9071C1.68742 13.9071 2.02819 14.0312 2.29095 14.2794L6.94675 18.6765V5.26796C6.94675 4.57 7.54618 4 8.2893 4C9.02832 4 9.63185 4.56612 9.63185 5.26796V18.6765L14.2794 14.2794C14.805 13.7831 15.6507 13.7831 16.1762 14.2794C16.7018 14.7757 16.7018 15.5745 16.1762 16.0708L9.2336 22.6278C8.98315 22.8643 8.64239 23 8.28519 23C7.928 23 7.58723 22.8682 7.33679 22.6278L0.394142 16.0708Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7005 6.92918C31.226 7.42551 31.226 8.22429 30.7005 8.72061C30.4377 8.96877 30.0969 9.09286 29.7521 9.09286C29.4072 9.09286 29.0664 8.96877 28.8037 8.72061L24.1479 4.32347V17.732C24.1479 18.43 23.5484 19 22.8053 19C22.0663 19 21.4628 18.4339 21.4628 17.732V4.32347L16.8152 8.72061C16.2896 9.21694 15.4439 9.21694 14.9184 8.72061C14.3928 8.22429 14.3928 7.42551 14.9184 6.92918L21.861 0.372244C22.1115 0.135714 22.4522 0 22.8094 0C23.1666 0 23.5074 0.131836 23.7578 0.372244L30.7005 6.92918Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.561baa6cae6885ec5e7199afda02697b.svg";
export { ForwardRef as ReactComponent };